import { useEffect } from "react";

const DEFAULT_TITLE = "Ayaseye";

export function useDocumentTitle(title: string | null | undefined): void {
    useEffect(() => {
        document.title =
            title != null && title.length > 0
                ? `${title} | ${DEFAULT_TITLE}`
                : DEFAULT_TITLE;

        return () => {
            document.title = DEFAULT_TITLE;
        };
    }, [title]);
}
